import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

import type { TooltipEvent, TooltipMode, TooltipSettings, TooltipState } from '@/types/tooltip';

import { createTooltipWindow } from './tooltipPolicy';

export const DEFAULT_TOOLTIP_DELAY_MS = 0;
export const DEFAULT_TOOLTIP_SKIP_MS = 300;

export function createTooltipSettings(delayMs: number, skipMs: number): TooltipSettings {
    return { delayMs, window: createTooltipWindow(skipMs) };
}

export const TooltipSettingsContext = createContext<TooltipSettings | null>(null);

interface TooltipContextValue {
    state: TooltipState;
    mode: TooltipMode;
    contentId: string;
    triggerRef: RefObject<HTMLElement | null>;
    send: (event: TooltipEvent) => void;
}

export const TooltipContext = createContext<TooltipContextValue | null>(null);

export function useTooltipContext(consumerName: string): TooltipContextValue {
    const context = useContext(TooltipContext);
    if (context === null) {
        throw new Error(`\`${consumerName}\` must be used within \`Tooltip\``);
    }
    return context;
}
